import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import Select, { CSSObjectWithLabel, StylesConfig } from 'react-select';

import { useIsMobile } from 'buyside/util/hooks/useIsMobile';

import styles from './filterSelectStyles.scss';

type OptionType = { label: string; value: string };

const FilterSelect: React.FC<{
  borderless?: boolean;
  clearable?: boolean;
  disabled?: boolean;
  options: OptionType[];
  paramName: string;
  placeholder?: string;
  text?: string;
}> = ({ borderless, clearable, disabled, options, paramName, placeholder = 'Select...', text }) => {
  const isMobile = useIsMobile();

  const [searchParams, setSearchParams] = useSearchParams();

  const currentParamValue = searchParams.get(paramName) || '';

  let selectStyles: StylesConfig<OptionType, false> = {
    option: (baseStyles, { isSelected }): CSSObjectWithLabel => ({
      ...baseStyles,
      color: isSelected ? '#ffffff' : '#333333'
    })
  };
  if (borderless)
    selectStyles = {
      ...selectStyles,
      indicatorSeparator: (baseStyles): CSSObjectWithLabel => ({
        ...baseStyles,
        display: 'none'
      }),
      control: (baseStyles): CSSObjectWithLabel => ({
        ...baseStyles,
        background: 'transparent',
        border: 'none',
        height: 'inherit',
        fontWeight: 'bold'
      }),
      singleValue: (baseStyles): CSSObjectWithLabel => ({
        ...baseStyles,
        color: 'inherit'
      })
    };

  const setParamValue = useCallback(
    (paramValue?: string) => {
      searchParams.set('page', '1');
      if (paramValue) {
        searchParams.set(paramName, paramValue);
      } else {
        searchParams.delete(paramName);
      }
      searchParams.delete('recommended');
      searchParams.delete('fpid');
      setSearchParams(searchParams);
    },
    [paramName, searchParams, setSearchParams]
  );

  return (
    <div className={styles.container}>
      {text && <label>{text}</label>}
      <Select
        classNamePrefix="Select"
        menuShouldScrollIntoView={Boolean(isMobile)}
        styles={selectStyles}
        isClearable={clearable || Boolean(currentParamValue)}
        name={paramName}
        value={options.filter(option => option.value === currentParamValue)}
        options={options}
        placeholder={placeholder}
        onChange={(selectedOption): void => setParamValue(selectedOption?.value)}
        isDisabled={disabled}
      />
    </div>
  );
};

export default FilterSelect;
